import type {Camera} from 'three';
import type {CameraProjectionType} from '../camera/view-orientation';

/**
 * 相机事件名称枚举。
 */
export enum CameraEventName {
    /** 相机投影类型已经变化。 */
    ProjectionTypeChanged = 'cameraProjectionTypeChanged',
    /** 当前活动相机的视图状态已经变化。 */
    StateChanged = 'cameraStateChanged',
}

/**
 * 相机投影类型变化事件载荷。
 */
export interface CameraProjectionTypeChangedEventPayload {
    /** 当前相机投影类型。 */
    projectionType: CameraProjectionType;
    /** 当前活动相机是否为透视相机。 */
    isPerspectiveCamera: boolean;
}

/**
 * 相机视图状态变化事件载荷。
 *
 * 说明：
 * 1. `camera` 是当前活动相机，消费方只读取本次渲染所需的投影参数；
 * 2. 视口尺寸随事件一并派发，避免消费方反向持有 Viewer 或 DOM provider；
 * 3. CameraManager 会在初始化、导航、投影切换和视口 resize 后派发该事件。
 */
export interface CameraStateChangedEventPayload {
    /** 当前活动相机。 */
    camera: Camera;
    /** 当前主视口 CSS 像素宽度。 */
    viewportWidth: number;
    /** 当前主视口 CSS 像素高度。 */
    viewportHeight: number;
}

/**
 * 相机事件注册列表。
 */
export const cameraEventNames: IEventBus.CadEventName[] = [
    CameraEventName.ProjectionTypeChanged,
    CameraEventName.StateChanged,
];
